import { useEffect } from 'react';


const AboutSection = ({ aboutSection }) => {


  if (!aboutSection) return null;

  return (
    <section className="mb-3">
      <div className="container">
        <div className="row">
          <h2
            className="sec-title text-center"
           
          >
            {aboutSection.heading}
          </h2>
        </div>

        <div className="row" >
          <p style={{ textAlign: 'justify' }}>
            {aboutSection.about_content}
          </p>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
